import React from "react"
import { Link } from "react-router-dom"

const HomePage = () => {
	return (
		<nav className="home-nav-wrapper">
			<Link to="/scenario-types" className="home-nav-link">
				Scenario Types
			</Link>
			<Link to="/scenarios" className="home-nav-link">
				Scenarios
			</Link>
			<Link to="/class-codes" className="home-nav-link">
				Class Codes
			</Link>
		</nav>
	);
}

export default HomePage